var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus, getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import { getInitialProgressionSelectionTemplates, getInitialTrafficFilters } from "@ane/exp-data/lib/defaultData/ProgressionSelectionInitialData";
import { MasterDataUtilInstance } from "@ane/exp-data/lib/utils/MasterDataUtils";
import { ProgressionSelectionUtilInstance } from "@ane/exp-data/lib/utils/ProgressionSelectionUtils";
import ___default from "lodash";
import { f as featureDataActions } from "../../FeatureDataActions-59549dc8.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const getDefaultState = () => {
  return {
    progressionSelection: getInitialProgressionSelectionTemplates(),
    allTrafficFilters: getInitialTrafficFilters(),
    expandedProgressions: {},
    pendingApprovalRequestSubmissions: [],
    approvalRequestValidationResult: getDefaultAsyncWrapperObj(),
    flightNameValidation: {},
    bulkEditProgressionStagesStatus: getDefaultAsyncWrapperObj()
  };
};
class FeatureDataReducer {
  resetFeatureDataActionsState(state) {
    return __spreadValues(__spreadValues({}, state), getDefaultState());
  }
  createFeatureV2(state, actionResult) {
    return state;
  }
  updateFeatureInternalV2(state, actionResult) {
    return state;
  }
  setFeatureAutoTriggerState(state, actionResult) {
    return state;
  }
  toggleProgressionState(state, actionResult) {
    const { progressionId, isExpanded } = actionResult.payload;
    const newState = ___default.cloneDeep(state);
    newState.expandedProgressions[progressionId] = isExpanded;
    return newState;
  }
  validateFlightNameStartedInternalFormik(state, actionResult) {
    const { name } = actionResult.payload;
    let newState = ___default.cloneDeep(state);
    newState = __spreadProps(__spreadValues({}, newState), {
      flightNameValidation: __spreadProps(__spreadValues({}, newState.flightNameValidation), {
        [name]: __spreadProps(__spreadValues({}, getDefaultAsyncWrapperObj()), { status: AsyncRequestStatus.Pending })
      })
    });
    return newState;
  }
  validateFlightNameInternalFormik(state, actionResult) {
    const { result, name } = actionResult.payload;
    let newState = ___default.cloneDeep(state);
    newState = __spreadProps(__spreadValues({}, newState), {
      flightNameValidation: __spreadProps(__spreadValues({}, newState.flightNameValidation), {
        [name]: getCompletedAsyncWrapperObj(result)
      })
    });
    return newState;
  }
  loadProgressionTemplates(state, actionResult) {
    const { mdsFilters, mdsProgressionTemplates, mdsExperimentTemplates, flightList, mdsControlTowerExperience } = actionResult.payload;
    const progressionSelection = MasterDataUtilInstance.getProgressionSelection(
      mdsFilters,
      mdsProgressionTemplates,
      mdsControlTowerExperience,
      mdsExperimentTemplates,
      flightList
    );
    const allTrafficFilters = MasterDataUtilInstance.getTrafficFiltersFromMDSFilters(
      actionResult.payload.mdsFilters,
      EnvironmentService.isUnifiedView
    );
    return __spreadProps(__spreadValues({}, state), {
      progressionSelection,
      allTrafficFilters
    });
  }
  createProgressionInternal(state, actionResult) {
    return state;
  }
  cloneProgressionInternal(state, actionResult) {
    return state;
  }
  createProgressionStageInternal(state, actionResult) {
    return state;
  }
  hideFeature(state, actionResult) {
    return state;
  }
  archiveProgressionInternal(state, actionResult) {
    return state;
  }
  actOnProgressionTargetInternal(state, actionResult) {
    return state;
  }
  onFetchExperimentJournal(state, actionResult) {
    return state;
  }
  fetchOperationCheckForFeatureInternal(state, actionResult) {
    return state;
  }
  updateProgressionStage(state, actionResult) {
    return state;
  }
  deleteProgressionStageInternal(state, actionResult) {
    return state;
  }
  loadProgressionStageInternal(state, actionResult) {
    return state;
  }
  cloneProgressionStageInternal(state, actionResult) {
    return state;
  }
  // double check these next two
  loadProgressionBudgetInfo(state, actionResult) {
    const { progressionId, progressionStages, budgetCalculationResults } = actionResult.payload;
    const { status, data } = budgetCalculationResults;
    return this.updateProgressionSelectionBudget(state, progressionId, status, progressionStages, data);
  }
  updateTrafficBudgetRequestStatus(state, actionResult) {
    const { progressionId, status } = actionResult.payload;
    return this.updateProgressionSelectionBudget(state, progressionId, status);
  }
  addToPendingSubmissions(state, actionResult) {
    const newRequest = actionResult.payload;
    const newState = ___default.cloneDeep(state);
    if (___default.every(newState.pendingApprovalRequestSubmissions, (r) => r.Gate.id !== newRequest.Gate.id)) {
      newState.pendingApprovalRequestSubmissions.push(newRequest);
    }
    return newState;
  }
  clearPendingSubmissions(state, actionResult) {
    const newState = ___default.cloneDeep(state);
    newState.pendingApprovalRequestSubmissions = [];
    return newState;
  }
  startApprovalRequestValidation(state, actionResult) {
    const newState = ___default.cloneDeep(state);
    newState.approvalRequestValidationResult.status = AsyncRequestStatus.Pending;
    return newState;
  }
  completeApprovalRequestValidation(state, actionResult) {
    const newState = ___default.cloneDeep(state);
    const request = actionResult.payload;
    newState.approvalRequestValidationResult = {
      status: request.Succeeded ? AsyncRequestStatus.Completed : AsyncRequestStatus.Failed,
      data: actionResult.payload.Message
    };
    return newState;
  }
  clearValidationRecord(state, actionResult) {
    const newState = ___default.cloneDeep(state);
    newState.approvalRequestValidationResult.status = AsyncRequestStatus.NotStarted;
    return newState;
  }
  updateProgressionSelectionBudget(state, progressionId, status, progressionStages, budgetResults) {
    const newState = ___default.cloneDeep(state);
    const progressionSelection = ProgressionSelectionUtilInstance.getProgressionSelectionFromState(progressionId, newState);
    const prevData = progressionSelection == null ? void 0 : progressionSelection.progressionTrafficBudget;
    if (status === AsyncRequestStatus.Completed && progressionStages && budgetResults) {
      const stageBudgetResults = progressionStages.map((stage, i) => {
        const budgetInfo = budgetResults[i].NumberlineUsages.length > 0 ? budgetResults[i].NumberlineUsages[0] : null;
        return { stageName: stage, budgetInfo };
      });
      if (progressionSelection) {
        progressionSelection.progressionTrafficBudget = {
          status,
          data: stageBudgetResults
        };
      }
    } else {
      if (progressionSelection) {
        progressionSelection.progressionTrafficBudget = {
          status,
          data: prevData ? prevData.data : null
        };
      }
    }
    return newState;
  }
}
const featureDataReducer = createReducer(featureDataActions, new FeatureDataReducer(), getDefaultState());
export {
  FeatureDataReducer,
  featureDataReducer as default,
  getDefaultState
};
//# sourceMappingURL=FeatureDataReducer.js.map
